/* eslint indent: off */
import PropTypes from 'prop-types';
import styled from 'styled-components';

const OuterTooltip = styled.div`
  position: relative;

  &:after {
    opacity: 0;
    ${({ $content }) => `content: '${$content}';`}
    position: absolute;
    z-index: 20;
    transition: opacity 0.2s ease-in-out;
    background: #767676;
    border-radius: 10px;
    color: white;
    font-weight: bold;
    padding: 5px 10px;
    font-size: 14px;
    white-space: nowrap;
    ${({ $width }) => $width && `width: ${$width}; white-space: normal;`}

    ${({ $position }) => {
      switch ($position) {
        case 'bottom':
          return 'top: calc(100% + 5px); left: 50%; transform: translateX(-50%);';
        case 'left':
          return 'right: calc(100% + 5px); top: 50%; transform: translateY(-50%);';
        case 'right':
          return 'left: calc(100% + 5px); top: 50%; transform: translateY(-50%);';
        default:
          return 'bottom: calc(100% + 5px); left: 50%; transform: translateX(-50%);';
      }
    }}
  }

  &:hover:after {
    opacity: 1;
  }
`;

const Tooltip = ({ title = null, children, position = 'top', width = null }) =>
  title && title.length > 0 ? (
    <OuterTooltip $content={title} $position={position} $width={width}>
      {children}
    </OuterTooltip>
  ) : (
    children
  );

Tooltip.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  position: PropTypes.string,
  width: PropTypes.string,
};

export default Tooltip;
